export const EstadoPoliza = [
    {
        codigo: 1,
        descripcion: "MUNDO_ROSA",
        texto: "Mundo Rosa",
        color: "lightpink"
    }, {
        codigo: 2,
        descripcion: "INDEPENDIENTE_VOLUNTARIO",
        texto: "Independiente V",
        color: "gray"
    }, {
        codigo: 3,
        descripcion: "ACTIVA",
        texto: "Póliza Activa",
        color: "yellow"
    }, {
        codigo: 4,
        descripcion: "PENDIENTE_INICIO",
        texto: "Pendiente Inicio",
        color: "yellow"
    }, {
        codigo: 5,
        descripcion: "RETIRADA",
        texto: "Retirada",
        color: "red"
    }, {
        codigo: 6,
        descripcion: "SIN_RELACION_SURA",
        texto: "Sin Relación Sura",
        color: "white"
    }, {
        codigo: 7,
        descripcion: "NO_APLICA",
        texto: "N/A",
        color: "white"
    }];

export const obtenerEstadoPoliza = (codigo: number) => {
    return EstadoPoliza.find(estadoPoliza => estadoPoliza.codigo === codigo);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/empresas_trasladadas/modelo/EstadoPoliza.ts